import { createEvent, restore } from "effector";

export const keyIntfShowDemRate = "show_dem_rate" //глобальная переменная, указывающая на то, нужно ли показывать оценки(для КРК не нужно показывать)
export const keyIntfCounters = "counters" //вроде счетчики
export const keyIntfCharges = "charges" //начисления
export const keyIntfSetDemRate = "set_dem_rate"  //не используется
export const keyIntfChangePwd = "change_pwd" //не используется
export const keyIntfContacts = "contacts" //кнопка "Связка с УК" в сайдбаре
export const keyIntfNews = "news" //кнопка "Новости" в сайдбаре
export const keyIntfActs = "acts"   //кнопка "Акты сверки"
export const keyIntfDemands = "demands" //кнопка "Заявки" в сайдбаре
export const keyIntfDemandsFree = "demands_free" // Подраздел бесплатные заявки
export const keyIntfDemandsPay = "demands_pay" // Подраздел платные заявки
export const keyIntfMap = "map" // Кнопка "График мусоровозов" в сайдбаер
export const keyIntfSettings = "settings" //Настройки в верхнем меню
export const keyIntfCategories = "categories" //Категории в заявках
export const keyIntfShowAndroid = "show_android" //Ссылка на приложение андроид в футере
export const keyIntfShowIos = "show_ios" //Ссылка на приложение айос в футере
export const keyIntfShowAddressInAccounts = "addressInAccount" //Ссылка на приложение айос в футере


export const setAccessDeniedPaths = createEvent<string[]>();//не используется
export const $accessDeniedPaths = restore<string[]>(setAccessDeniedPaths, []); //не используется

export const setAccessDeniedIntfs = createEvent<string[]>();
export const $accessDeniedIntfs = restore<string[]>(setAccessDeniedIntfs, [keyIntfCharges, keyIntfCounters]);

export const isPathAccessDenied = (path: string) => {
   return $accessDeniedPaths.getState().indexOf(path) != -1
}

export const isIntfAccessDenied = (intfKey: string) => {
    // console.log(intfKey,$accessDeniedIntfs.getState())
    return $accessDeniedIntfs.getState().indexOf(intfKey) != -1
}
